import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import type { SidebarPreferenceStore, SidebarPreferenceState } from './types/use-sidebar-preference-store-types';

const initialState: SidebarPreferenceState = {
  preference: null,
};

export const useSidebarPreferenceStore = create<SidebarPreferenceStore>()(
  devtools(
    persist(
      set => ({
        ...initialState,

        setPreference: preference => set({ preference }, false, 'SET_PREFERENCE'),

        clearPreference: () => set({ preference: null }, false, 'CLEAR_PREFERENCE'),
      }),
      {
        name: 'sidebar:user-preference',
      }
    ),
    { enabled: process.env.NODE_ENV === 'development' }
  )
);
